import React, { useState } from 'react';
import {
  GECKO_CONSTS,
  GeckoForm,
  GeckoFormField,
  GeckoModal,
  GeckoModalService,
} from 'ui';
import GeckoErrorsAlert from '../../../../components/GeckoErrorsAlert';

const RelationshipModal = ({
  destinationModuleLabel,
  relatedModuleLabel,
  submitRelationship,
  salesforceFields,
  isEdit,
  deleteRelationship,
}) => {
  const [submissionErrors, setSubmissionErrors] = useState([]);

  const onSubmit = ({ moduleIndex }) =>
    submitRelationship(salesforceFields[moduleIndex])
      .then((result) => {
        if (result.success === false) {
          return setSubmissionErrors(result.errors);
        }
        new GeckoModalService().close(result.data);
      })
      .catch((errorResponse) => {
        return setSubmissionErrors(
          errorResponse?.errors || [
            {
              code: 500,
              title: 'Could not create new relationship',
              detail: errorResponse?.raw || 'An error occurred',
            },
          ]
        );
      });

  const onDelete = (moduleIndex) => {
    return () => {
      deleteRelationship(salesforceFields[moduleIndex])
        .then((result) => {
          if (result.success === false) {
            return setSubmissionErrors(result.errors);
          }
          const {moduleRelationshipId} = salesforceFields[moduleIndex]
          new GeckoModalService().close({moduleRelationshipId, method: 'delete'});
        })
        .catch((errorResponse) => {
          return setSubmissionErrors(
            errorResponse?.errors || [
              {
                code: 500,
                title: 'Could not delete relationship',
                detail: errorResponse?.raw || 'An error occurred',
              },
            ]
          );
        });
    }
  }

  const currentRelationshipSelected = (moduleIndex) => {
    return () => moduleIndex === 0 && isEdit;
  }

  const getInitialValues = () => {
    const value = isEdit ? 0 : null
    return {moduleIndex: value}
  }

  const modalButtons = (handleSubmit, moduleIndex) => {
    return [
    {
      name: 'Delete relationship',
      type: GECKO_CONSTS.BTN_TYPE_NAKED,
      icon: 'far fa-trash-alt',
      handler: onDelete(moduleIndex),
      hideWhen: () => !isEdit,
      disabledWhen: () => !currentRelationshipSelected(moduleIndex)()
    },
    {
      name: 'Save relationship',
      type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
      icon: 'far fa-save',
      handler: handleSubmit,
      disabledWhen: () => currentRelationshipSelected(moduleIndex)() || moduleIndex === null
    },
  ]};

  return (
    <GeckoForm
      onSubmit={onSubmit}
      requiredFields={['moduleIndex']}
      initialValues={getInitialValues()}
    >
      {({ values, handleSubmit }) => (
        <GeckoModal
          name="Add relationship"
          btns={modalButtons(handleSubmit, values.moduleIndex)}
        >
          <GeckoErrorsAlert errors={[...submissionErrors]} />
          <div className="row">
            <div className="col">
              <p>
                Select Salesforce field to relate {destinationModuleLabel} to{' '}
                {relatedModuleLabel}
              </p>
            </div>
            <GeckoFormField
              fieldType="select"
              name="moduleIndex"
              options={salesforceFields.map((field, index) => ({
                value: index,
                label: field.attributeLabel,
              }))}
              label="Salesforce field"
              required
            />
          </div>
        </GeckoModal>
      )}
    </GeckoForm>
  );
};

export default RelationshipModal;
